// Initial ESL config
import 'core/config/esl.config';

import {onDocumentReady} from '@exadel/esl/modules/esl-utils/dom/ready';

import {ESLToggleableDispatcher, ESLToggleable} from '@exadel/esl/modules/esl-toggleable/core';
import {ESLPanel} from '@exadel/esl/modules/esl-panel/core';
import {ESLPanelGroup} from '@exadel/esl/modules/esl-panel-group/core';
import {ESLTrigger} from '@exadel/esl/modules/esl-trigger/core';
import {ESLTab, ESLTabs} from '@exadel/esl/modules/esl-tab/core';
import {ESLScrollbar} from '@exadel/esl/modules/esl-scrollbar/core';
import {ESLDragToScrollMixin} from '@exadel/esl/modules/esl-drag-to-scroll/core';
import {ESLAlert} from '@exadel/esl/modules/esl-alert/core';
import {ESLA11yGroup} from '@exadel/esl/modules/esl-a11y-group/core';
import {ESLPopup} from '@exadel/esl/modules/esl-popup/core';
import {ESLTooltip} from '@exadel/esl/modules/esl-tooltip/core';
import {ESLAnimateMixin} from '@exadel/esl/modules/esl-animate/core';
import {ESLRelatedTarget} from '@exadel/esl/modules/esl-related-target/core';
import {ESLOpenState} from '@exadel/esl/modules/esl-open-state/core';
import {ESLStickyBoxMixin} from '@exadel/esl/modules/esl-sticky-box/core';

import {HPEFootnotes} from 'hpe-wc/hpe-footnotes';
import {HPENote} from 'hpe-wc/hpe-note';
import {HpeNoteIgnore} from 'hpe-wc/hpe-note-ignore-mixin';
import {HPEImage} from 'core/legacy/esl.image';


// TODO: A lot of extra staff - cleanup/lazyload
onDocumentReady(() => {
  // ESL Components
  ESLToggleableDispatcher.init();
  ESLToggleable.register();

  ESLPanelGroup.register();
  ESLPanel.register();

  ESLTrigger.register();
  ESLTab.register();
  ESLTabs.register();

  ESLScrollbar.register();
  ESLDragToScrollMixin.register();

  ESLPopup.register();
  ESLTooltip.register();

  ESLAlert.register();
  ESLAlert.init();

  ESLA11yGroup.register();

  HPEFootnotes.register();
  HPENote.register();
  HpeNoteIgnore.register();

  ESLAnimateMixin.register();
  ESLRelatedTarget.register();
  ESLOpenState.register();

  HPEImage.register();

  ESLStickyBoxMixin.register();
});

// GN v4 loader
(function () {
  if (!document.querySelector('header')?.matches('.gn-v4')) return;
  import(/* webpackChunkName: "hpe-gn/gn-header-v4"*/'hpe-gn/gn-header-v4');
  import(/* webpackChunkName: "hpe-gn/search-box"*/'hpe-gn/search-box');
})();

// GN v5 loader
(function () {
  if (!document.querySelector('header')?.matches('.gn-v5')) return;
  import(/* webpackChunkName: "hpe-gn/gn-header-v5"*/'hpe-gn/gn-header-v5');
  import(/* webpackChunkName: "hpe-gn/search-box"*/'hpe-gn/search-box');
})();

// Defer third-priority modules
import(/* webpackChunkName: "hpe-share-async" */'core/hpe-share');
